export const CHANGE_DATERANGE = "CHANGE_DATERANGE";

export const CHANGE_LOCATION = "CHANGE_LOCATION";

export const CHANGE_PROJECT = "CHANGE_PROJECT";

export const UPDATE_REPORT_DATA = "UPDATE_REPORT_DATA";

export const RESET_REPORT_DATA = "RESET_REPORT_DATA";

export const RESET_FILTER = "RESET_FILTER";

export const ADD_TOAST_MESSAGE = "ADD_TOAST_MESSAGE";

export const REMOVE_TOAST_MESSAGE = "REMOVE_TOAST_MESSAGE";

export const ADD_ACTIONABLE_POP_UP = "ADD_ACTIONABLE_POP_UP";

export const REMOVE_ACTIONABLE_POP_UP = "REMOVE_ACTIONABLE_POP_UP";

export const POPUP_CONFIRM = "POPUP_CONFIRM";

export const ADD_CHARGER_TO_LOCATION_MAP = "ADD_CHARGER_TO_LOCATION_MAP";
